import React from "react";
import "./CarViewCircles.css";
import { Link } from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import CarModel from "../CarModel/CarModel";

const CarViewCircles = props => (
  <div className="CirclesDiv">
    <Grid
      container
      spacing={1}
      style={{ textAlign: "center", marginTop: "5px" }}
    >
      <Grid item>
        <br />{" "}
      </Grid>
      <Grid item xs>
        <img src="/img/img-circle.png" className="CircleImg" />
        <div className="SmallTextCircles" style={{ marginTop: "-90px" }}>
          Versión
        </div>
        <div className="BigTextCircles" style={{ marginTop: "-5px" }}>
          {props.version}
        </div>
      </Grid>
      <Grid item xs>
        <img src="/img/img-motor.png" className="CircleImg" />
        <div className="SmallTextCircles" style={{ marginTop: "-55px" }}>
          {props.motor}
        </div>
      </Grid>
      <Grid item xs>
        <img src="/img/img-circle.png" className="CircleImg" />
        <div className="SmallTextCircles" style={{ marginTop: "-85px" }}>
          Tipo
        </div>
        <div className="SmallTextCircles" style={{ marginTop: "-2px" }}>
          <b>{props.tipo}</b>
        </div>
      </Grid>
      <Grid item xs>
        <img src="/img/img-color.png" className="CircleImg" />
        <div className="SmallTextCircles" style={{ marginTop: "-57px" }}>
          <b>{props.color}</b>
        </div>
      </Grid>
      <Grid item xs>
        <img src="/img/img-circle.png" className="CircleImg" />
        <div className="SmallTextCircles" style={{ marginTop: "-90px" }}>
          Modelo
        </div>
        <div className="BigTextCircles" style={{ marginTop: "-5px" }}>
          {props.year}
        </div>
      </Grid>
      <Grid item xs>
        <img src="/img/img-gear.png" className="CircleImg" />
        <div className="SmallTextCircles" style={{ marginTop: "-60px" }}>
          Transmisión
        </div>
        <div className="SmallTextCircles" style={{ marginTop: "-2px" }}>
          <b>{props.gear}</b>
        </div>
      </Grid>

      <Grid item xs>
        <br />{" "}
      </Grid>
    </Grid>
  </div>
);

export default CarViewCircles;
